<div class="modal-header bg-main-beige">
  <h5 class="modal-title poppins-text d-flex justify-content-between align-items-center w-100 mb-0">
    {{ title | translate }}
    <button class="pointer-style icon-button display-6" type="button" aria-label="Fermer"
            (click)="modal.dismiss()">
      <i class="fa-solid fa-circle-xmark"></i>
    </button>
  </h5>
</div>
<div class="modal-body poppins-text py-4">{{ message | translate }}</div>
<div class="modal-footer bg-main-beige">
  <app-button-with-icon [label]="cancelLabel"
                        [additionalClass]="'bg-secondary btn-style beige-text'"
                        [isTransparent]="true"
                        (buttonClickHandler)="modal.dismiss()">
  </app-button-with-icon>
  <app-button-with-icon [label]="confirmLabel"
                        [additionalClass]="'btn-style ' + confirmClass"
                        [isTransparent]="true"
                        (buttonClickHandler)="modal.close(true)">
  </app-button-with-icon>
</div>
